import React from 'react';

/**
 * AIコンシェルジュ機能详细说明 - SEO优化新增
 * 突出AIコンシェルジュ与一般チャットボット的差异
 */
export const AIConciergeDetailSection: React.FC = () => {
  return (
    <section className="w-full px-4 md:px-10 lg:px-40 py-16 bg-white">
      <div className="max-w-[900px] w-full mx-auto">
        <h2 className="text-2xl md:text-3xl font-black text-solution-text mb-6 text-center">
          AIコンシェルジュ機能 - 人間のように自然な対話
        </h2>
        <p className="text-solution-text-secondary text-base leading-relaxed mb-8 text-center">
          GBase Supportは単なるチャットボットではなく、AIコンシェルジュとして機能します。
          事前に登録されたFAQに機械的に答えるだけでなく、お客様の質問の意図を理解し、 最適な情報を提供します。
        </p>

        <h3 className="text-xl font-bold text-solution-text mb-6 text-center">一般的なチャットボットとの違い</h3>
        <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
          <p className="text-solution-text-secondary text-base leading-relaxed">
            例えば「子供連れで行けるレストランはありますか？」という質問に対し、
            従来のチャットボットは「レストラン一覧」を表示するだけですが、
            AIコンシェルジュは「キッズメニューがある」「座敷がある」など、
            子供連れに適した条件を自動で考慮して回答します。
          </p>
        </div>
      </div>
    </section>
  );
};

export default AIConciergeDetailSection;
